<style>
#partnersList_wrapper{
  width: 100% !important;
}
.marker {
  background-color: Yellow;
}
.tooltip-inner {
  max-width: 100% !important;
}
</style>
<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
              <b-overlay :show="showLoader" no-wrap></b-overlay>
              <custom-alert v-if="displayAlert==true" id="alert_box" :message="alertMessage" v-on:showedAlert="resetAlert"></custom-alert>
                <section class="col-lg-12 connectedSortable table-area mt-3 pr-0 pl-0 mb-3 text-center">
                    <div class="card">
                        <div class="card-body table-responsive table-head pt-2">
                            <div class="row">
                                <div class="col-md-8 text-left px-0 bor-bot pb-3">
                                    <h1 class="m-0 text-dark pt-2 text-left px-0">Member Dashboard</h1>
                                </div>
                                <div class="col-md-4 bor-bot pr-0">
                                    <div class="text-right pb-3 pt-1">
                                        <ol class="breadcrumb float-sm-right pr-0">
                                            <li class="breadcrumb-item"><a href="/admin/dashboard">Home</a></li>
                                            <li class="breadcrumb-item"><Breadcrumbs/></li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                               <div class="col-md-12 p-0 memberdasbordsec mt-4 text-left">
                                   <div>
                                    <b-card no-body>
                                        <b-tabs pills card vertical>
                                        <b-tab title="Banner" active>
                                            <b-card-text>
                                                <div class="row text-left">
                                                    <div class="col-md-12 text-right mt-4">
                                                        <button type="button" v-b-modal.modal-previewcenter class="btn btn darkblubtn btn-outline-primary btn-outline-primary px-3">Preview</button>
                                                    </div>
                                                    <div class="col-md-12 mt-4 imagesec pl-0">
                                                        <div class="rectimage">
                                                            <img :src="bannerUrl" style="width: 100%;"/>
                                                        <div class="atcmntbtn" :class="bannerErrors.has('image') ? 'is-invalid' : ''">
                                                            <input type="file" @mousedown="bannerErrors.clear('image')" name="avatar" @change="fileChange(1)" ref="fileBanner" accept="image/png, image/jpeg">
                                                        </div>
                                                          <b-form-invalid-feedback :state="!bannerErrors.has('image')">
                                                            {{ bannerErrors.get("image") }}</b-form-invalid-feedback>
                                                        </div>
                                                        <p class="mt-3 mb-1 text-right notetext">Please upload 1657 X 318 image</p>
                                                    </div>
                                                    <div class="col-md-1 px-0">
                                                        <label>Heading</label>
                                                      <span v-b-tooltip.hover title="Maximum 60 characters">
                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                      </span>
                                                    </div>
                                                    <div class="col-md-5">
                                                        <input class="form-control" @keydown="bannerErrors.clear('title')" :class="bannerErrors.has('title') ? 'is-invalid' : ''" v-model="form.title" @input="cancelFunction('cancelButton1')">
                                                        <b-form-invalid-feedback :state="!bannerErrors.has('title')">
                                                        {{ bannerErrors.get("title") }}</b-form-invalid-feedback>
                                                    </div>
                                                    <div class="col-md-6">
                                                    </div>
                                                    <div class="col-md-1 mt-4 px-0">
                                                        <label>Text</label><span v-b-tooltip.hover title="Maximum 200 characters">
                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                      </span>
                                                    </div>
                                                    <div class="col-md-11 mt-4">
                                                        <textarea rows="3" @keydown="bannerErrors.clear('content')" :class="bannerErrors.has('content') ? 'is-invalid form-control' : 'form-control'" v-model="form.content" @input="cancelFunction('cancelButton1')"></textarea>
                                                        <b-form-invalid-feedback :state="!bannerErrors.has('content')">
                                                        {{ bannerErrors.get("content") }}</b-form-invalid-feedback>
                                                    </div>
                                                    <div class="col-md-12 text-right mt-4">
                                                        <button type="button" disabled id="cancelButton1" @click="cancelForm(1)" class="btn btn-secondary mr-3 px-3">Cancel</button>
                                                        <button type="button" @click="saveData(1, 1)" class="btn btn darkblubtn btn-outline-primary btn-outline-primary px-4">Save</button>
                                                    </div>
                                                </div>
                                            </b-card-text>
                                        </b-tab>
                                        <b-tab title="Image">
                                            <b-card-text>
                                               <div class="row text-left">
                                                    <div class="col-md-12 text-right mt-4">
                                                        <button type="button" v-b-modal.modal-previewcenterdbimage class="btn btn darkblubtn btn-outline-primary btn-outline-primary px-3">Preview</button>
                                                    </div>
                                                    <div class="col-md-5 mt-4 imagesec pl-0">
                                                        <div class="rectimage">
                                                            <img :src="imageUrl"  style="width: 100%;"/>
                                                        <div class="atcmntbtn" :class="imageErrors.has('image') ? 'is-invalid' : ''">
                                                            <input type="file" @mousedown="imageErrors.clear('image')"  @change="fileChange(6)" ref="fileImage" name="avatar" accept="image/png, image/jpeg">
                                                        </div>
                                                          <b-form-invalid-feedback class="mt-6"  :state="!imageErrors.has('image')">
                                                            {{ imageErrors.get("image") }}</b-form-invalid-feedback>
                                                        </div>
                                                        <p class="mt-2 text-right notetext">Please upload 800 X 450 image</p>
                                                    </div>
                                                    <div class="col-md-7">
                                                    </div>
                                                    <div class="col-md-1 px-0">
                                                        <label>Text</label><span v-b-tooltip.hover title="Maximum 200 characters">
                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                      </span>
                                                    </div>
                                                    <div class="col-md-11">
                                                        <textarea rows="3" :class="imageErrors.has('content') ? 'is-invalid form-control' : 'form-control'" v-model="imageForm.content" @keydown="imageErrors.clear('content')" @input="cancelFunction('cancelButton2')"></textarea>
                                                        <b-form-invalid-feedback :state="!imageErrors.has('content')">
                                                        {{ imageErrors.get("content") }}</b-form-invalid-feedback>
                                                    </div>
                                                 <div class="col-md-1">
                                                   <label>Link</label>
                                                   <span v-b-tooltip.hover>
                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                      </span>
                                                 </div>
                                                 <div class="col-md-11 mt-4">
                                                   <input :class="imageErrors.has('link') ? 'is-invalid form-control' : 'form-control'" v-model="imageForm.link"  @keydown="imageErrors.clear('link')">
                                                   <b-form-invalid-feedback :state="!imageErrors.has('link')">
                                                     {{ imageErrors.get("link") }}</b-form-invalid-feedback>
                                                 </div>
                                                    <div class="col-md-12 text-right mt-4">
                                                        <button type="button" disabled id="cancelButton2" @click="cancelForm(6)" class="btn btn-secondary mr-3 px-3">Cancel</button>
                                                        <button type="button" @click="saveData(1, 6)" class="btn btn darkblubtn btn-outline-primary btn-outline-primary px-4">Save</button>
                                                    </div>
                                                </div>
                                            </b-card-text>
                                        </b-tab>
                                        </b-tabs>
                                    </b-card>
                                    </div> 
                               </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <b-modal id="modal-previewcenter" size="xl" title="" hide-footer="true" :modal-class="mobileclass">
            <b-tabs content-class="mt-3">
                <b-tab title="Web View" active>
                    <div class="row">
                        <div class="col-md-12 webview">
                            <div class="rectimage">
                              <img :src="bannerUrl"/>
                              <div class="imgovlycont">
                                <h3>{{form.title}}</h3>
                                <p><span>{{ form.content }}</span></p>
                              </div>
                            </div> 
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Mobile View">
                    <div class="row">
                        <div class="col-md-12 mobview">
                            <div class="rectimage">
                              <img :src="bannerUrl"/>
                              <div class="imgovlycont">
                                <h3>{{form.title}}</h3>
                                <p><span>{{ form.content }}}</span></p>
                              </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-modal>

        <b-modal id="modal-previewcenterdbimage" size="xl" title="" hide-footer="true" :modal-class="dasboardclass">
            <b-tabs content-class="mt-3">
                <b-tab title="Web View" active>
                    <div class="row">
                        <div class="col-md-6 webview">
                            <div class="dbrectimage">
                              <img :src="imageUrl"/>
                              <div class="imgovlycont">
                                <p><span>{{ imageForm.content }}</span></p>
                              </div>
                            </div> 
                        </div>
                        <div class="col-md-6">
                        </div>
                    </div>
                </b-tab>
                <b-tab title="Mobile View">
                    <div class="row">
                        <div class="col-md-12 mobview mobileview">
                            <div class="dbrectimage">
                              <img :src="imageUrl"/>
                              <div class="imgovlycont">
                                <p><span>{{ imageForm.content }}</span></p>
                              </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-modal>
    </section>
</template>

<script>

  import axios from "axios";
  import CustomAlert from "../CustomAlert";
  import Errors from "../../Errors";
  import "datatables.net-responsive-dt/js/responsive.dataTables";
  import "datatables.net-dt/css/jquery.dataTables.min.css";
  import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";
  import $ from "jquery";


  export default {
    components:{
      CustomAlert
    },
    data() {
      return {
        dasboardclass:'previewpopupmobilesec dasboardimgsection popupfullheight',
        mobileclass: 'previewpopupmobilesec membrdasboarpopup popupfullheight',
        bannerErrors: new Errors(),
        imageErrors: new Errors(),
        iframe: {
          src: '/'
        },
        bannerUrl:'/img/mdrectangleimage.f47903fa.svg',
        imageUrl:'/img/mdrectangleimage.f47903fa.svg',
        form:{
          title:'',
          content:'',
          image:'',
          section_id:'',
          page_id:''
        },
        resetForm:{
          title:'',
          content:'',
          banner:'/img/mdrectangleimage.f47903fa.svg'
        },
        resetImageForm:{
          content:'',
          banner:'/img/mdrectangleimage.f47903fa.svg'
        },
        imageForm:{
          content:'',
          image:'',
          link:'',
          section_id:'',
          page_id:''
        },
        logoUrl:'/img/mdrectangleimage.f47903fa.svg',
        textareamodal: 'textareacontmodal',
      }
    },
    methods: {
      fileChange(section) {

        if(section == 1){
          const file = this.$refs.fileBanner.files[0];
          this.form.image = file;
          this.bannerUrl = URL.createObjectURL(file);
          $('#cancelButton1').removeAttr("disabled");
        }
        if(section == 6){
          const file = this.$refs.fileImage.files[0];
          this.imageForm.image = file;
          this.imageUrl = URL.createObjectURL(file);
          $('#cancelButton2').removeAttr("disabled");
        }
      },
      getDashboardData()
      {
        let url = this.basePath+'api/cms/page/1';
        axios.get(url, { headers:this.adminHeaders })
            .then((res) => {
              let results = res.data.data;
              for(let k in results){
                 if(results[k].section_id == 1){
                   this.form.title = results[k].title;
                   this.form.content = results[k].content;
                   this.bannerUrl = this.basePath+results[k].image;
                   this.resetForm.banner = this.basePath+results[k].image;
                   this.resetForm.content = results[k].content;
                   this.resetForm.title = results[k].title;
                   this.form.banner_img = results[k].image;
                 }
                if(results[k].section_id == 6){
                  this.imageForm.content = results[k].content;
                  this.imageForm.link = results[k].link;
                  this.imageUrl = this.basePath+results[k].image;
                  this.resetImageForm.banner = this.basePath+results[k].image;
                  this.resetImageForm.content = results[k].content;
                  this.imageForm.banner_img = results[k].image;
                }
              }


            })
            .catch((error) => {
              console.log('Error:'+ error);
            }).finally(() => {
        });
      },
      saveData(pageId, sectionId)
      {
        this.showLoader = true;
        let formData = new FormData();
        if(sectionId == 1){
          this.form.section_id = sectionId;
          this.form.page_id = pageId;
          Object.entries(this.form).forEach(([key, value]) => {
            formData.append(key, value);
          });
        }
        if(sectionId == 6){
          this.imageForm.section_id = sectionId;
          this.imageForm.page_id = pageId;
          Object.entries(this.imageForm).forEach(([key, value]) => {
            formData.append(key, value);
          });
        }
        this.$set(this.adminHeaders, 'Content-Type', 'multipart/form-data');
        axios.post(this.basePath+'api/cms/section', formData, {headers: this.adminHeaders})
            .then((response) => {
              this.showLoader = false;
              if (response.data.status == 'success') {
                if(sectionId == 1){
                  this.resetForm.banner = this.bannerUrl;
                  this.resetForm.content = this.form.content;
                  this.resetForm.title = this.form.title;
                  $('#cancelButton1').attr('disabled', true);
                }
                if(sectionId == 6){
                  this.resetForm.banner = this.imageUrl;
                  this.resetForm.content = this.imageForm.content;
                  $('#cancelButton2').attr('disabled', true);
                }
                //alert("Section has been " + message + ".");
                this.displayAlert = true;
                this.alertMessage = response.data.message;
              }
            }).catch((error) => {
          this.showLoader = false;
          this.onFail(error.response.data.errors, sectionId);
        });
      },
      cancelForm(section)
      {
        if(section == 1){
          this.form.title = this.resetForm.title;
          this.form.content = this.resetForm.content;
          this.bannerUrl = this.resetForm.banner;
          $('#cancelButton1').attr('disabled', true);
        }
        if(section == 6){
          this.imageForm.title = this.resetImageForm.title;
          this.imageForm.content = this.resetImageForm.content;
          this.imageUrl = this.resetImageForm.banner;
          $('#cancelButton2').attr('disabled', true);
        }
      },
      onFail(errors,sectionId) {
        if(sectionId == 1)
        {
          this.bannerErrors.record(errors);
        }
        if(sectionId == 6)
        {
          this.imageErrors.record(errors);
        }
        if(sectionId == 3)
        {
          this.partnerErrors.record(errors);
        }
        //this.errors.record(errors);
      },
      cancelFunction(id){
        $('#'+id).removeAttr("disabled")
      }
    },
    mounted() {
        this.getDashboardData();
    }
  }
</script>